import { Box } from '@modusign/design-system';

interface ChipLabelProps {
  active: boolean;
  children: React.ReactChildren | string;
  htmlFor: string;
}

export default function ChipLabel({ active, children, htmlFor }: ChipLabelProps) {
  return (
    <Box
      as="label"
      fontWeight="regular"
      htmlFor={htmlFor}
      mb="10px"
      mr={3}
      px={4}
      py={2}
      sx={{
        backgroundColor: active
          ? 'statusBackgroundEmphasisUltraLight'
          : 'statusBackgroundNeutralUltraLight',
        borderColor: active ? 'buttonBorderEmphasisBase' : 'statusBorderNeutralLight',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderRadius: '100px',
        userSelect: 'none',
        color: active ? 'textEmphasisBase' : 'textNeutralSlightlyLight',
        width: 'fit-content',
        '&:hover': {
          cursor: 'pointer',
        },
      }}
    >
      {children}
    </Box>
  );
}
